module.exports = __webpack_public_path__ + "static/impressions-e831644e52d5de32a9c1d705d99ab7b0.svg";